import {myRequest} from '@/utils/util'
import Vue from 'vue'
import {Message} from "element-ui";

Vue.prototype.$message = Message;

const homeInfo = (name) => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_home', {name: name}
    ).then(res => {
      resolve(res.data)
    });
  })
};

const recentReview = (type, id, start = 0, limit = 10) => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_review/recent', {type: type, id: id, start: start, limit: limit}
    ).then(res => {
      resolve(res.data)
    });
  })
};

const changeReview = (type, id, state) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_review/change', {type: type, id: id, state: state}
    ).then(res => {
      resolve(res.data)
    });
  })
};


const verifyToken = () => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_auth').then(res => {
      resolve(res.data);
    })
  })
};

const loginSubmit = (email, password) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_login', {
      email: email,
      password: password
    }).then(res => {
      resolve(res.data);
    })
  })
};

const getChallengeList = () => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_challenge/list', {}
    ).then(res => {
      resolve(res.data)
    });
  })
};

const deleteChallenge = (id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_challenge/delete', {id: id}
    ).then(res => {
      resolve(res.data)
    });
  })
};

const getChallengeDetail = (id) => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_challenge/detail', {id: id}
    ).then(res => {
      resolve(res.data)
    });
  })
};

const challengeTopChange = (id, state) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_challenge/top', {id: id, state: state}
    ).then(res => {
      resolve(res.data)
    });
  })
};

const challengeSave = (form) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_challenge/save', form, true
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getProductOption = () => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_product/option/list', {}
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveProductOption = (option_detail) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_product/option/save', option_detail, true
    ).then(res => {
      resolve(res.data);
    })
  })
};

const deleteProductOption = (template_id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_product/option/delete', {template_id: template_id},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const detailProductOption = (template_id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_product/option/detail', {template_id: template_id},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getProductCategory = () => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_product/category/list', {},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveProductCategoryName = (name_en, name_cn, id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_product/category/name', {
          name_en: name_en,
          name_cn: name_cn,
          id: id
        },
    ).then(res => {
      resolve(res.data);
    })
  })
};

const deleteProductCategory = (id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_product/category/delete', {id: id},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const orderProductCategory = (list) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_product/category/order', list, true,
    ).then(res => {
      resolve(res.data);
    })
  })
};

const orderVendorCategory = (list) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_vendor/category/order', list, true,
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getBrandList = () => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_brand/list'
    ).then(res => {
      resolve(res.data);
    })
  })
};

const savebrandDetail = (detail) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_brand/detail/save', detail, true
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getBrandDetail = (id) => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_brand/detail', {id: id}
    ).then(res => {
      resolve(res.data);
    })
  })
};

const deleteBrand = (id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_brand/delete', {id: id}
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveProductDetail = (detail) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_product/detail/save', detail, true
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getProductList = () => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_product/list'
    ).then(res => {
      resolve(res.data);
    })
  })
};

const deleteProduct = (id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_product/delete', {id: id}
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getProductDetail = (id) => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_product/detail', {id: id}
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getVendorList = () => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_vendor/list'
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getVendorCategory = () => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_vendor/category/list', {},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getVendorLocation = () => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_vendor/location/list', {},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const deleteVendor = (id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_vendor/delete', {id: id}
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getVendorDetail = (id) => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_vendor/detail', {id: id}
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveVendorDetail = (detail) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_vendor/detail/save', detail, true
    ).then(res => {
      resolve(res.data);
    })
  })
};

const deleteVendorCategory = (id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_vendor/category/delete', {id: id},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveVendorCategory = (name_en, name_cn, id, file_path) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_vendor/category/save', {
          name_en: name_en,
          name_cn: name_cn,
          id: id,
          file_path: file_path
        },
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getOrderList = (state, start_time, end_time, order_id) => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_order/list', {
          state: state,
          start_time: start_time,
          end_time: end_time,
          order_id: order_id
        },
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getOrderDetail = (id) => {
  return new Promise(resolve => {
    myRequest('GET', '/bk_order/detail', {
          order_id: id
        },
    ).then(res => {
      resolve(res.data);
    })
  })
};

const orderMarkUsed = (id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_order/mark_used', {
      order_id: id
    }).then(res => {
      resolve(res.data);
    })
  })
};

const orderTrack = (data) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_order/track', data, true
    ).then(res => {
      resolve(res.data);
    })
  })
};

const orderTrackUpdate = (number, code, phone) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_order/track/update', {number: number, code: code, phone: phone}
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getBackendUser = (id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_user/get', {id: id}
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveBackendUser = (data) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_user/save', data, true
    ).then(res => {
      resolve(res.data);
    })
  })
};

const deleteBackendUser = (id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_user/delete', {id: id}
    ).then(res => {
      resolve(res.data);
    })
  })
};


const getBannerList = () => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_banner/list', {}
    ).then(res => {
      resolve(res.data);
    })
  })
};

const orderBanner = (list) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_banner/order', list, true,
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getBannerOptions = () => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_banner/options', {},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveBanner = (id, banner_type, banner_target, file_path) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_banner/save', {
          id: id,
          banner_type: banner_type,
          banner_target: banner_target,
          file_path: file_path
        },
    ).then(res => {
      resolve(res.data);
    })
  })
};


const deleteBanner = (id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_banner/delete', {id: id},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getConvertInfo = () => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_convert/info', {},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveConvertStep = (step_to_meter, step_to_kcal) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_convert/step', {
          step_to_meter: step_to_meter,
          step_to_kcal: step_to_kcal
        },
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveConvertBalance = (step_to_balance, balance_to_cny) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_convert/balance', {
          step_to_balance: step_to_balance,
          balance_to_cny: balance_to_cny
        },
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getDailyInfo = () => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_daily/info', {},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveDailyInfo = (data) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_daily/save', data, true
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getAlbumList = () => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_music/album', {}
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveAlbum = (name, description, id, file_path) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_music/album/save', {
          name: name,
          description: description,
          id: id,
          file_path: file_path
        },
    ).then(res => {
      resolve(res.data);
    })
  })
};

const deleteAlbum = (id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_music/album/delete', {id: id},
    ).then(res => {
      resolve(res.data);
    })
  })
};


const getPlaylist = (id = '') => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_music/playlist', {id: id}
    ).then(res => {
      resolve(res.data);
    })
  })
};

const savePlaylist = (name, author, album_id, id, image_path, audio_path) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_music/playlist/save', {
          name: name,
          author: author,
          album_id: album_id,
          id: id,
          image_path: image_path,
          audio_path: audio_path
        },
    ).then(res => {
      resolve(res.data);
    })
  })
};

const deletePlaylist = (id) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_music/playlist/delete', {id: id},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getUser = (data) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_user/list', data,
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveUser = (data) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_user/save', data,
    ).then(res => {
      resolve(res.data);
    })
  })
};

const createUserCode = (uid) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_user/create_code', {uid},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const deleteUserCode = (uid) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_user/delete_code', {uid},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const getConfig = (key) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_config/get', {key},
    ).then(res => {
      resolve(res.data);
    })
  })
};

const saveConfig = (data) => {
  return new Promise(resolve => {
    myRequest('POST', '/bk_config/save', data,
    ).then(res => {
      resolve(res.data);
    })
  })
};

export {
  homeInfo,
  recentReview,
  changeReview,
  loginSubmit,
  verifyToken,
  getChallengeList,
  deleteChallenge,
  getChallengeDetail,
  challengeTopChange,
  challengeSave,
  getProductOption,
  saveProductOption,
  deleteProductOption,
  detailProductOption,
  getProductCategory,
  saveProductCategoryName,
  deleteProductCategory,
  orderProductCategory,
  saveProductDetail,
  getProductList,
  deleteProduct,
  getProductDetail,
  getVendorList,
  getVendorCategory,
  deleteVendor,
  getVendorLocation,
  getVendorDetail,
  saveVendorDetail,
  orderVendorCategory,
  deleteVendorCategory,
  saveVendorCategory,
  getOrderList,
  getOrderDetail,
  orderTrack,
  orderTrackUpdate,
  getBackendUser,
  saveBackendUser,
  deleteBackendUser,
  getBannerList,
  orderBanner,
  getBannerOptions,
  saveBanner,
  deleteBanner,
  getConvertInfo,
  saveConvertStep,
  saveConvertBalance,
  getDailyInfo,
  saveDailyInfo,
  getAlbumList,
  getPlaylist,
  saveAlbum,
  deleteAlbum,
  savePlaylist,
  deletePlaylist,
  getBrandList,
  savebrandDetail,
  getBrandDetail,
  saveUser,
  deleteBrand,
  getUser,
  createUserCode,
  deleteUserCode,
  getConfig,
  saveConfig,
  orderMarkUsed
}
